module.exports = __webpack_public_path__ + "static/media/obs1.29c7f382.png";